export default (settings: any) => {
  if (!settings['integratedHtmlElements']) {
    return 0
  }
  return (1 / 3) + settings['integratedHtmlElements'] * 0.5
}
